import * as React from 'react';

import cn from 'classnames';
import ProgressiveImage from 'react-progressive-image';
import { Link } from 'react-router-dom';

import * as urls from '../../urls';

const styles = require('./VenueCard.scss');

interface Props {
    imageURL: string;
    venueId: number;
    name: string;
    isPriced: boolean;

    onLinkClick: (link: string) => void;
}

export const VenueCard: React.FC<Props> = (props) => (
    <div className={styles.className}>
        <Link
            to='#'
            className={styles.imageWrapper}
            onClick={(e: React.SyntheticEvent<HTMLAnchorElement>) => {
                e.preventDefault();
                props.onLinkClick(urls.getVenueURL(props.venueId));
            }}
        >
            <ProgressiveImage src={props.imageURL} placeholder={'https://place-hold.it/300x150/f0f0f0?text='}>
                {(src: string) => <img src={src} />}
            </ProgressiveImage>
        </Link>
        <h3 className={styles.venueName}>
            <Link
                to='#'
                className={styles.venueNameLink}
                onClick={(e: React.SyntheticEvent<HTMLAnchorElement>) => {
                    e.preventDefault();
                    props.onLinkClick(urls.getVenueURL(props.venueId));
                }}
            >
                {props.name}
            </Link>
        </h3>
        <div className={styles.venueCardFooter}>
            {props.isPriced ? (
                <a href={urls.getContactVenueURL(props.venueId)} className={cn(styles.button, styles.requestQuoteButton)}>
                    Contact Venue
                </a>
            ) : (
                <a className={cn(styles.button, styles.requestQuoteButton)} href={urls.getQuoteRequestURL(props.venueId)}>
                    Request Quote
                </a>
            )}
        </div>
    </div>
);

export default VenueCard;
